import { api } from "@/lib/api";

export async function extractFromFlyer(pageId) {
  const { data } = await api.post(`/pages/${pageId}/extract-from-flyer`, null, { timeout: 45000 });
  return data;
}
